import { createGlobalStyle, keyframes } from 'styled-components';
import { defaultTheme } from '../config';

const waveTop = keyframes`
from {

  top: -210px;
  transform: rotateX(0deg);
}
to{

  top: -180px;
  transform: rotateX(30deg);
}
`;

const waveBottom = keyframes`
from {

  bottom: -210px;
  transform: rotateX(0deg);
}
to{

  bottom: -180px;
  transform: rotateX(30deg);

}
`;

export default createGlobalStyle`

@font-face {
    font-family: Montserrat;
    src: url("/assets/fonts/sun-regular.ttf") format("truetype");
}


@font-face {
    font-family: MontserratBold;
    src: url("/assets/fonts/sun-heavy.ttf") format("truetype");
}


*{
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  outline: 0
}

html{
  width: 100%;
  min-height: 100vh !important;

  background-attachment: fixed;
  background-size: cover;
  background: ${defaultTheme.defaultBackground};
  background: url('/assets/evento/Fundo.png') no-repeat center;
  background-attachment: fixed;
  background-size: cover;

}

body {
  background: ${defaultTheme.defaultBackground};
  background: url('/assets/evento/Fundo.png') no-repeat center;
  background-attachment: fixed;
  background-size: cover;
  background-size: cover;
  background-attachment: fixed;
  color: #fff;
  -webkit-font-smoothing: antialiased;
  padding: 0;
  margin: 0 !important;
  min-height: 100vh !important;
  min-height: 100% !important;
  position: relative;




}

#root{
  min-height: 100vh;

}

body, input, button{
  font-family: Helvetica,  sans-serif;
  font-size: 16px;
}

h1,h2,h3,h4,h5,h6, strong{
font-weight: bold;
font-family:  'MontserratBold',Helvetica,  sans-serif;
color: rgb(50,70,107) !important;
line-height: 1.4rem;
}

h2{

      font-size: 22px;
      margin-bottom: 10px;
}

p, span, li, nav{
  font-family:'Montserrat',Helvetica,  sans-serif;
  line-height: 18px;
}

button{
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;

  >svg {
    margin: 0 5px;
  }
}


.computerOnly{
display: flex;
@media (max-width: 750px) {
    display: none;
  }
}

.mobileOnly{
display: none;
@media (max-width: 750px) {
    display: flex;
  }
}

button.defaultButton {
         margin-top: 10px;
      width: 200px;
      min-width: 200px;
      padding: 20px;
      text-align: center;
      background: ${defaultTheme.defaultBackground} !important;
      color: ${defaultTheme.defaultColor}  !important;

      display: flex;
      justify-content: center;
      text-align: center;

      transition: background 0.5s;
      border: 0;
      border-radius: 8px;
      margin: auto;
      margin-top: 5px;

      &:hover {
        background: ${defaultTheme.defaultBackground}  !important;
      }
    }

    button.defaultButtonMini {
         margin-top: 0px !important;
         padding: 10px !important;
      width:auto !important;
      min-width:auto !important;

      text-align: center !important;
      justify-content: center !important;
      background: ${defaultTheme.defaultBackground} !important;
      color: ${defaultTheme.defaultColor}  !important;

      display: flex  !important;
      justify-content: center !important;
      margin: 5px;
      border-radius: 8px;


      transition: background 0.5s;
      border: 0;
      border-radius: 2px;

      &:hover {
        background: ${defaultTheme.defaultBackground}  !important;
      }
    }

    .closeButton{
      padding: 10px;
      border: 0;
      opacity: 0.8;
      background: #555;
      color: #fff;
      transition: 0.5s all;

      margin: 5px;
      &:hover{
        opacity: 1;
      }
    }


    a {
      text-decoration: none !important;
    }

    .separator {
    width: 100%;

    height: 2px;
    background: rgb(50,70,107);
    margin: 10px 0;
  }

.colorWhite{
  color: #fff !important;
  >h2, > nav, >p, >strong {
      color: #fff !important;
    }
  >div { color: #fff !important;
    >h2, > nav, >p, >strong {
      color: #fff !important;
    }

  }
}

  .priceGrid {
    display: flex;
    width: 100%;
    flex-wrap: wrap;
    padding: 20px;
>a {
    >div {
      background: #fff;
      border-radius: 8px;
      box-shadow: 2px 2px 2px rgba(0, 0, 0, 0.2);
      margin: 20px;
      padding: 20px;
      min-width: 300px;
      transition: 0.5s all;
      cursor: pointer;
    

      >strong {
      margin-bottom: 20px;
      max-width: 300px;
      display: flex;
      min-height: 40px;
      align-items: center;
      justify-content: center;
    }

      >nav{
        padding: 10px;
        display: flex;
        justify-content: space-between;
        border-top: 1px solid rgb(50,70,107);

        >span{
          color: rgb(50,70,107);
        }
      }
      
      &:hover {
    box-shadow: 4px 4px 4px rgba(0, 0, 0, 0.7);
    transform: translateY(-10px) translateX(-10px);
  }

    }}

  
    


  }

`;
